import { useState } from 'react';
import { Grid, IconButton, Tooltip } from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import SettingsIcon from '@mui/icons-material/Settings';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PropTypes from 'prop-types';
import { style } from 'constant/constants';
import { formatTierName } from 'utils/utils';

const MenuStyles = {
  fontFamily: style.fontFamily,
  color: style.LIGHT.primary
};

const MarkupMenu = ({ setAddOpenModal, setTierName, setTierPercentage, tiers }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleTierSelection = (tier) => {
    const currentTier = formatTierName(tier?.name);
    setTierName(currentTier);
    setTierPercentage(tier?.percentage);
    setAddOpenModal(true);
    handleClose();
  };

  return (
    <div>
      <Grid display="flex" justifyContent="space-between">
        <IconButton
          id="demo-customized-button"
          aria-controls={open ? 'demo-customized-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          variant="contained"
          disableElevation
          onClick={handleClick}>
          <Tooltip title="Update Tiers">
            <SettingsIcon fontSize="large" />
          </Tooltip>
        </IconButton>
      </Grid>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            minWidth: '150px',
            mt: 1.5,
            '&::before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0
            }
          }
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
        {tiers?.map((tier, index) => (
          <MenuItem
            key={tier}
            style={MenuStyles}
            onClick={() => handleTierSelection(tier)}
            disableRipple>
            <AttachMoneyIcon style={MenuStyles} />
            {`Tier ${index + 2}`}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

MarkupMenu.propTypes = {
  setAddOpenModal: PropTypes.func,
  setTierName: PropTypes.func,
  tiers: PropTypes.array,
  setTierPercentage: PropTypes.func
};

export default MarkupMenu;
